export default "__VITE_ASSET__BJFof0NZ__"